<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item href="#home">
                    <router-link to="/AllDocuments">
                          News and Notifications
                    </router-link>
                  </b-breadcrumb-item>

              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">

          <div id="Fin1">
            <b-row>
              <b-col cols="6">
                  <h1 class="heading">News and Notifications</h1>
              </b-col>

           </b-row>
           <p class="content">
             <ul id="news">
              <li>
                <span class='notificationHeader' >Notice</span>
                <br><span style='font-size:0.9rem;'><a href="https://www.apdcl.org/website/docs/documents/notice/prepaid_to_postpaid_conversion.pdf" target="_blank"> Conversion of LT postpaid connections (having smart meters installed) into prepaid connections. </a> ||  <a href="https://www.apdcl.org/website/docs/documents/notice/annexure_postpaid_to_prepaid.pdf" target="_blank"><strong> Annexure A - D </strong></a></span>
              </li>
               <li v-for="item in getNews" :key="item.name">
                 <span class='notificationHeader' >{{ item.type }}</span>
                 <br><span style='font-size:0.9rem;' v-html="item.name"></span>
               </li>
           </ul>
            </p>
          </div>

          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'
export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
  data() {
      return {
        getNewsFields: [
            { key: 'type', label: '',thStyle: {width: '40vw'} },
           { key: 'name', label: '',thStyle: {width: '30vw'} },

          ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getNews'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveNews'
    ]),
    showDoc(id){
      var link = this.getDocument.filter(function(obj) { return obj.name == id; });
      console.log(link);
      window.open(this.$urlCommon +"/"+ link[0].path);
    }
  },
  beforeMount() {
    if(this.getNews.length == 0){
      this.retrieveNews();

    }
  }
}
</script>

<style scoped="true">
li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
